import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';

import { FormHelper } from '../../helpers/form-helper';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.scss']
})
export class UpdateUserComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	private key: string;

  constructor(private dialogRef: MdDialogRef<UpdateUserComponent>,
							private formBuilder: FormBuilder,
							private userService: UserService) {
		super();
		this.subscriptionManager = new Subscription();

		this.buildForm();
	}

  ngOnInit() { }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			name: new FormControl('', Validators.required),
			lastname: new FormControl('', Validators.required),
			email: new FormControl('', [Validators.required, Validators.email])
		});
	}

	public updateForm(user: User): void {
		this.key = user.$key;

		this.form.controls['name'].setValue(user.name);
		this.form.controls['lastname'].setValue(user.lastname);
		this.form.controls['email'].setValue(user.email);
	}

	public async submitForm(): Promise<any> {
		let user: User = this.form.value;

		delete user.email;
		delete user.password;
		delete user.createdAt;
		delete user.updatedAt;

		await this.userService.updateUser(this.key, user);

		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/update-user/update-user.component.ts